import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { MatButtonModule, MatIconModule } from '@angular/material';

import { GLinkSearchBarComponent } from './search-bar.component';

@NgModule({
    declarations: [
        GLinkSearchBarComponent
    ],
    imports     : [
        CommonModule,
        RouterModule,

        MatButtonModule,
        MatIconModule
    ],
    exports     : [
        GLinkSearchBarComponent
    ]
})
export class GLinkSearchBarModule
{
}
